/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  tableCellClasses,
  styled,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PortraitIcon from '@mui/icons-material/Portrait';
import LockIcon from '@mui/icons-material/Lock';
import Phone from '@mui/icons-material/Phone';
import Email from '@mui/icons-material/Email';
import axios from '../../../utils/axios';
import UIContext from '../../../context/UIContext';
import NoResultsFound from '../../../components/NoResultsFound';
import air3 from '../../../media/Images/air3.jpg';
import sea2 from '../../../media/Images/sea2.jpg';
import otherImage from '../../../media/Images/other.jpg';
import airIcon from '../../../media/Images/air-icon-3.png';
import seaIcon from '../../../media/Images/seaicon.png';
import globeIcon from '../../../media/Images/globe.png';

// ==================== STYLED ====================
const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: { backgroundColor: '#257180' },
  whiteSpace: 'nowrap',
  fontSize: '0.8rem',
  padding: '6px 8px',
});

const StyledBodyCell = styled(TableCell)({
  fontSize: '0.78rem',
  padding: '4px 8px',
  verticalAlign: 'middle',
});

const RequiredLabel = ({ children }) => (
  <span>
    {children}
    <span style={{ color: '#d32f2f', marginLeft: 2 }}>*</span>
  </span>
);

// ==================== OPTIONS ====================
const searchByOptions = [
  { label: 'Phone Number', value: 'phonenumber' },
  { label: 'Customer Name', value: 'customername' },
  { label: 'Email ID', value: 'emailid' },
];

const searchByFilterOptions = [
  { label: 'Phone Number', value: 'phonenumber' },
  { label: 'Customer Name', value: 'customername' },
  { label: 'Email ID', value: 'emailid' },
];

const preBookingShipmentTypes = [
  { label: 'Air Cargo - Srilanka', value: 'courier', accent: '#3b82f6', image: air3, icon: airIcon },
  { label: 'Air Cargo - India', value: 'courier', accent: '#3b82f6', image: air3, icon: airIcon },
  { label: 'Air Cargo - Other Countries', value: 'courier', accent: '#3b82f6', image: otherImage, icon: globeIcon },
  { label: 'Sea Cargo - Srilanka', value: 'cargo', accent: '#14b8a6', image: sea2, icon: seaIcon },
];

const shipmentTypeOptionsIN = [
  { label: 'Air Cargo - Srilanka', value: 'ACSL' },
    { label: 'Air Cargo Other Countries', value: 'OC'},
];

const shipmentTypeOptionsUK = [
  { label: 'Air Cargo - Srilanka', value: 'ACSL' },
  { label: 'Air Cargo - India', value: 'ACI' },
  { label: 'Air Cargo Other Countries', value: 'OC'},
  { label: 'Sea Cargo - Srilanka', value: 'SCSL' },
];

const shipmentTypeOptionsSL = [
   { label: 'Air Cargo - OverAll', value: 'ACO' },
];

const shipmentTypeLabels = {
  ACSL: 'Air Cargo - Srilanka',
  ACI: 'Air Cargo - India',
  OC: 'Air Cargo Other Countries',
  SCSL: 'Sea Cargo - Srilanka',
  ACO: 'Air Cargo - OverAll',
};

const shipmentTypeFilterOptions = [
  { label: 'All', value: 'All' },
  { label: 'Air Cargo', value: 'courier' },
  { label: 'Sea Cargo', value: 'cargo' },
];

const documentTypeOptions = [
  { label: 'Non Document', value: 'NonDocument' },
  { label: 'Document', value: 'Document' },
];

const dimensionOptions = [
  { label: 'CM', value: 'CM' },
  { label: 'Inch', value: 'Inch' },
];

const payModeOptions = [
  { label: 'Cash', value: 'Cash' },
  { label: 'Credit', value: 'Credit' },
  { label: 'To Pay', value: 'ToPay' },
];

const shipModeOptions = [
  { label: 'Air', value: 'Air' },
  { label: 'Sea', value: 'Sea' },
];

const getSavedShipmentTypeValue = (record = {}) => {
  const savedValue = String(record.ShipmentTypeValue || record.shipmentTypeValue || '').trim().toUpperCase();
  if (Object.prototype.hasOwnProperty.call(shipmentTypeLabels, savedValue)) return savedValue;

  const shipmentType = String(record.ShipmentType || record.shipmentType || '').toLowerCase();
  const shipMode = String(record.ShipMode || record.shipMode || '').toLowerCase();
  if (shipmentType.includes('cargo') || (!shipmentType && (shipMode.includes('cargo') || shipMode.includes('sea')))) {
    return 'SCSL';
  }
  if (shipmentType.includes('india')) return 'ACI';
  if (shipmentType.includes('other')) return 'OC';
  return getDefaultShipmentTypeValue();
};

const bookingStatusOptions = [
  { label: 'Select' , value: ''},
  { label: 'Parcel Collected', value: 'PC' },
  { label: 'Cancelled', value: 'CA' },
  { label: 'Postponed', value: 'PO' },
];

const bookingStatusFilterOptions = [
  { label: 'All', value: 'ALL' },
  { label: 'Parcel Collected', value: 'PC' },
  { label: 'Cancelled', value: 'CA' },
  { label: 'Postponed', value: 'PO' },
];

const normalizeBookingStatus = (value) => {
  const status = String(value ?? '')
    .trim()
    .toUpperCase();
  if (!status) return '';
  if (status === 'PC' || status === 'PARCEL COLLECTED') return 'PC';
  if (status === 'CA' || status === 'CANCELLED') return 'CA';
  if (status === 'PO' || status === 'POSTPONED') return 'PO';
  return '';
};

const getStatusRowBackground = (value) => {
  const status = normalizeBookingStatus(value);
  if (!status) return '#f5f5f5';
  if (status === 'CA') return '#fdecea';
  if (status === 'PO') return '#fff4e5';
  return '#e8f5e9';
};

const normalizeShipmentTypeValue = (value) => {
  const v = (value === null || value === undefined ? '' : String(value)).trim().toLowerCase();
  if (!v) return '';
  if (v.includes('cargo') || v.includes('sea')) return 'cargo';
  if (v.includes('courier') || v.includes('air')) return 'courier';
  return v;
};

const NUMERIC_9_2_REGEX = /^\d{0,9}(\.\d{0,2})?$/;
const sanitizeNumericInput = (rawValue) => {
  if (rawValue === null || rawValue === undefined) return '';
  let value = String(rawValue).replace(/[^0-9.]/g, '');
  const firstDot = value.indexOf('.');
  if (firstDot !== -1) {
    value = value.slice(0, firstDot + 1) + value.slice(firstDot + 1).replace(/\./g, '');
  }
  const [intPart, decPart] = value.split('.');
  const limitedInt = (intPart || '').slice(0, 9);
  const limitedDec = decPart !== undefined ? decPart.slice(0, 2) : undefined;
  return limitedDec !== undefined ? `${limitedInt}.${limitedDec}` : limitedInt;
};
const isValidNumericInput = (value) => {
  if (value === '' || value === null || value === undefined) return true;
  return NUMERIC_9_2_REGEX.test(String(value));
};
const sanitizeAlphanumeric150 = (rawValue) => {
  if (rawValue === null || rawValue === undefined) return '';
  const cleaned = String(rawValue).replace(/[^\p{L}\p{N}\s.,\-_/()&'"]/gu, '');
  return cleaned.slice(0, 150);
};

const ORIGIN_COUNTRY_MAP = {
  IN: { CountryName: 'India', aliases: ['india', 'in'] },
  UK: { CountryName: 'United Kingdom', aliases: ['united kingdom', 'uk', 'great britain'] },
  SL: { CountryName: 'Srilanka', aliases: ['srilanka', 'sri lanka', 'sl', 'ceylon'] },
};

const normalizeOrigin = (value) => {
  const normalized = String(value || '').trim().toUpperCase();
  if (normalized.includes('UK') || normalized.includes('UNITED KINGDOM')) return 'UK';
  if (normalized.includes('SL') || normalized.includes('SRI LANKA') || normalized.includes('SRILANKA')) return 'SL';
  return 'IN';
};

const getDefaultShipmentTypeValue = () => (normalizeOrigin(sessionStorage.getItem('Origin')) === 'SL' ? 'ACO' : 'ACSL');

const getShipmentModeFromValue = (value) =>
  ['SCSL', 'CARGO', 'SEA', 'CARGO_SRILANKA'].includes(String(value || '').trim().toUpperCase())
    ? 'cargo'
    : 'courier';

const getRecordShipmentMode = (record = {}) => {
  const shipmentTypeValue = record.ShipmentTypeValue ?? record.shipmentTypeValue;
  if (shipmentTypeValue) return getShipmentModeFromValue(shipmentTypeValue);
  return normalizeShipmentTypeValue(
    record.ShipmentType || record.shipmentType || record.ShipMode || record.shipMode
  );
};

const initialForm = {
  searchByField: 'phonenumber',
  PreBookOrderId: 0,
  PreBookOrderNo: '',
  PreBookDate: moment().format('YYYY-MM-DD'),
  CompanyId: Number(sessionStorage.getItem('CompanyId') || 0),
  BranchId: Number(sessionStorage.getItem('BranchId') || 0),
  CustomerId: 0,
  ShipperLinerId: 0,
  CountryId: 0,
  SourceId: 0,
  ShipMode: getShipmentModeFromValue(getDefaultShipmentTypeValue()),
  ShipmentTypeValue: getDefaultShipmentTypeValue(),
  PreDocType: 'NonDocument',
  Dimension: 'CM',
  NoOfBox: 1,
  IntoBooking: 'N',
  SameAsCustomer: 'N',
  SName: '',
  SContactNo: '',
  SAtlNo: '',
  SEmailId: '',
  SAdd1: '',
  SAdd2: '',
  SAdd3: '',
  SCity: '',
  SenderCountry: '',
  SenCountryId: 0,
  SenProvince: '',
  SenStateId: 0,
  Senpincode: '',
  RName: '',
  RContactNo: '',
  RAtlNo: '',
  REmailId: '',
  RAdd1: '',
  RAdd2: '',
  RAdd3: '',
  RCity: '',
  ReceiverCountry: '',
  RecCountryId: 0,
  RecProvince: '',
  RecStateId: 0,
  RecPincode: '',
  Branch: '',
  PrePayMode: 'Cash',
  ShipModeValue: 'Air',
  BookingStatus: '',
  Status: '',
  IsDraft: 'Y',
  PickupMiles: '',
  PickupCharges: '',
  PickupAddress: '',
  PickupBranch: '',
  PickupBranchId: 0,
  PickupDate: moment().format('YYYY-MM-DD'),
  PickupTime: '00:00',
  PostalCode: '',
  Remark: '',
  FiscalYear: '',
  SatlNo: '',
  RatlNo: '',
  SenCntryCode: '',
  RecCntryCode: '',
  PreZoneId: 0,
  OpType: 'New',
};

const DEFAULT_FILTERS = {
  searchBy: 'phonenumber',
  searchCustomer: null,
  searchValue: '',
  shipmentType: 'All',
  fromDate: moment().startOf('month').format('YYYY-MM-DD'),
  toDate: moment().format('YYYY-MM-DD'),
  branch: 'ALL',
  bookingStatus: 'ALL',
  isDraft: 'N',
};

// ==================== MAIN ====================
const PreBooking = () => {
  const userRole = sessionStorage.getItem('userRole');
  const origin = normalizeOrigin(sessionStorage.getItem('Origin'));
  const isSalesUser = userRole === 'Sales';
  const isAdmin = userRole === 'Admin';
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const fieldRefs = useRef({});

  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isEditing, setIsEditing] = useState(false);
  const [showBookingDetails, setShowBookingDetails] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const branchListRef = useRef([]);
  const [branchListLoaded, setBranchListLoaded] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [receiverList, setReceiverList] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [shipperList, setShipperList] = useState([]);
  const [shipperCountryList, setShipperCountryList] = useState([]);
  const [senderStateList, setSenderStateList] = useState([]);
  const [receiverStateList, setReceiverStateList] = useState([]);
  const [withoutuser, setWithoutuser] = useState(false);
  const [isDialogOpen, setDialogOpenState] = useState(false);

  const [selectedShipment, setSelectedShipment] = useState('');
  const [isFilterExpanded, setFilterExpanded] = useState(true);
  const [customerMismatchOpen, setCustomerMismatchOpen] = useState(false);
  const [customerMismatchMessage, setCustomerMismatchMessage] = useState('');
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [preBookingToDelete, setPreBookingToDelete] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitAttempted, setSubmitAttempted] = useState(false);

  const isDraftEditing =
    isEditing &&
    String(form.IsDraft || '')
      .trim()
      .toUpperCase() === 'Y';

  const isBookedInWindows = String(form.IsBooked ?? form.isBooked ?? '').trim().toUpperCase() === 'Y';
  const isBookedInWeb = String(form.IsBookedWeb ?? form.isBookedWeb ?? '').trim().toUpperCase() === 'Y';
  const isBookedPreBooking = isBookedInWindows || isBookedInWeb;
  const isFieldDisabled = (allowBookedEdit = false) => isBookedPreBooking && !allowBookedEdit;

  // ==================== SENDER COUNTRY ====================
  const getOriginCountry = useCallback(
    (list = []) => {
      if (!list.length) return null;
      const target = ORIGIN_COUNTRY_MAP[origin] || ORIGIN_COUNTRY_MAP.IN;
      const byCode = list.find(
        (c) =>
          String(c.CountryCode || '')
            .trim()
            .toUpperCase() === origin.toUpperCase()
      );
      if (byCode) return byCode;
      const normalizedTarget = target.CountryName.toLowerCase();
      const byName = list.find((c) => {
        const name = String(c.CountryName || '')
          .trim()
          .toLowerCase();
        return target.aliases.includes(name) || name === normalizedTarget;
      });
      if (byName) return byName;
      const byPartial = list.find((c) => {
        const name = String(c.CountryName || '')
          .trim()
          .toLowerCase();
        return target.aliases.some((alias) => name.includes(alias) || alias.includes(name));
      });
      return byPartial || null;
    },
    [origin]
  );

  const senderCountryOptions = useMemo(() => {
    const match = getOriginCountry(countryList);
    return match ? [match] : [];
  }, [countryList, getOriginCountry]);

  const receiverCountryOptions = useMemo(() => {
    if (!shipperCountryList.length) return countryList;
    const selectedCountry = countryList.find((c) => Number(c.CountryId) === Number(form.RecCountryId || 0));
    return selectedCountry &&
      !shipperCountryList.some((c) => Number(c.CountryId) === Number(selectedCountry.CountryId))
      ? [...shipperCountryList, selectedCountry]
      : shipperCountryList;
  }, [countryList, form.RecCountryId, shipperCountryList]);

  const [filters, setFilters] = useState({ ...DEFAULT_FILTERS });
  const [filterCustomerInputValue, setFilterCustomerInputValue] = useState('');

  // ==================== API ====================
  const loadBranchList = useCallback(async () => {
    try {
      showLoading();
      const response = await axios.post(
        'Approval/LoginApprovalRoute/GetBranchLog',
        {
          UserId: sessionStorage.getItem('UserId'),
          CompanyId: sessionStorage.getItem('CompanyId'),
        },
        { headers: { Country: origin } }
      );
      const branches = Array.isArray(response.data) ? response.data : [];
      branchListRef.current = branches;
      setBranchList(branches);
    } catch (error) {
      console.log(error);
      branchListRef.current = [];
      setBranchList([]);
    } finally {
      setBranchListLoaded(true);
      hideLoading();
    }
  }, [origin, showLoading, hideLoading]);

  const loadCountryList = useCallback(async () => {
    try {
      const response = await axios.post('/signup/GetCountryList');
      setCountryList(response.data || []);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const loadCustomerList = useCallback(async (withAllCustomers = false) => {
    try {
      const userID = withAllCustomers ? 0 : sessionStorage.getItem('UserId');
      const companyId = sessionStorage.getItem('CompanyId');
      const response = await axios.get(`/Transactions/SalesControls/GetCustomerHelpForSE/${companyId}/${userID}/0`);
      const filteredList = (response.data || []).filter((item) => item.active === 'Y' && item.WebApproved === 'Y');
      setCustomerList(filteredList);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const loadReceiverList = useCallback(async () => {
    const customerId = Number(form.CustomerId || 0);
    if (!customerId) {
      setReceiverList([]);
      return;
    }

    try {
      const response = await axios.post(
        '/Transactions/PreBooking/ReceiverHelp',
        {
          CompanyId: Number(sessionStorage.getItem('CompanyId') || 0),
          CustomerId: customerId,
          ShipmentType: form.ShipMode,
        },
        { headers: { Country: origin } }
      );
      setReceiverList(response.data || []);
    } catch (error) {
      console.log(error);
      setReceiverList([]);
    }
  }, [form.CustomerId, form.ShipMode, origin]);

  const handleWithoutUserToggle = () => {
    const nextValue = !withoutuser;
    setWithoutuser(nextValue);
    loadCustomerList(nextValue);
    setFilterCustomerInputValue('');
    setFilters((prev) => ({ ...prev, searchCustomer: null, searchValue: '' }));
  };

  const loadShipperList = useCallback(async () => {
    try {
      const response = await axios.post('/master/agent/GetAllAgentForWeb', {
        CompanyId: sessionStorage.getItem('CompanyId'),
      });
      const list = (response.data || []).map((item) => {
        const shipperId = Number(
          item.AgentId ?? item.ShipperLinerId ?? item.shipperlinerid ?? item.SHIPPERLINERID ?? 0
        );
        const shipperName =
          item.AgentName ?? item.WebShipperName ?? item.ShipperLinerName ?? item.SHIPPERLINERNAME ?? '';
        return {
          ...item,
          AgentId: shipperId,
          ShipperLinerId: shipperId,
          AgentName: shipperName,
          ShipperLinerName: shipperName,
          ShipperType: item.SHIPPERTYPE ?? item.ShipperType ?? item.shipperType ?? '',
        };
      });
      setShipperList(list);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const filteredShipperList = useMemo(() => {
    const shipmentType = normalizeShipmentTypeValue(form.ShipMode);
    return shipperList.filter(
      (shipper) => String(shipper.ShipperType || '').trim().toLowerCase() === shipmentType
    );
  }, [form.ShipMode, shipperList]);

  const loadShipperCountryList = useCallback(async (shipperId) => {
    if (!shipperId) {
      setShipperCountryList([]);
      return;
    }
    try {
      const response = await axios.get(`/master/agent/GetShipperReceiverCountry/${shipperId}`);
      const list = (response.data || []).map((item) => {
        const countryId = Number(item.CountryId ?? item.countryid ?? item.COUNTRYID ?? 0);
        const countryName = item.CountryName ?? item.countryname ?? item.COUNTRYNAME ?? '';
        const countryCode = item.CountryCode ?? item.countrycode ?? item.COUNTRYCODE ?? '';
        return { ...item, CountryId: countryId, CountryName: countryName, CountryCode: countryCode };
      });
      setShipperCountryList(list);
    } catch (error) {
      console.log(error);
      setShipperCountryList([]);
    }
  }, []);

  const getSenderState = useCallback(async (countryid) => {
    try {
      if (!countryid) {
        setSenderStateList([]);
        return;
      }
      const response = await axios.get(`/signup/GetAllState/${countryid}`);
      setSenderStateList(response.data || []);
    } catch (error) {
      console.log(error);
      setSenderStateList([]);
    }
  }, []);

  const getReceiverState = useCallback(async (countryid) => {
    try {
      if (!countryid) {
        setReceiverStateList([]);
        return;
      }
      const response = await axios.get(`/signup/GetAllState/${countryid}`);
      setReceiverStateList(response.data || []);
    } catch (error) {
      console.log(error);
      setReceiverStateList([]);
    }
  }, []);

  const loadList = useCallback(
    async (overrideFilters = null, showAllBranches = withoutuser) => {
      if (isSalesUser && !showAllBranches && !branchListLoaded) return;

      const source = overrideFilters || filters || {};
      const effectiveFilters = {
        searchBy: source.searchBy ?? DEFAULT_FILTERS.searchBy,
        searchValue: source.searchValue ?? DEFAULT_FILTERS.searchValue,
        shipmentType: source.shipmentType ?? DEFAULT_FILTERS.shipmentType,
        fromDate: source.fromDate || DEFAULT_FILTERS.fromDate,
        toDate: source.toDate || DEFAULT_FILTERS.toDate,
        branch: source.branch ?? DEFAULT_FILTERS.branch,
        bookingStatus: source.bookingStatus ?? DEFAULT_FILTERS.bookingStatus,
        isDraft: source.isDraft ?? DEFAULT_FILTERS.isDraft,
      };

      try {
        showLoading();
        const selectedBranchId =
          !effectiveFilters.branch || effectiveFilters.branch === 'ALL'
            ? 0
            : typeof effectiveFilters.branch === 'object'
            ? effectiveFilters.branch.BranchId || 0
            : Number(effectiveFilters.branch) || 0;
        const assignedBranchIds = [...new Set(
          branchListRef.current
            .map((branch) => Number(branch.BranchId))
            .filter((branchId) => Number.isInteger(branchId) && branchId > 0)
        )];
        const branchIdForApi = isSalesUser
          ? showAllBranches
            ? 0
            : selectedBranchId || (assignedBranchIds.length ? 0 : -1)
          : selectedBranchId;
        const branchIdsForApi =
          isSalesUser && !showAllBranches && !selectedBranchId ? assignedBranchIds.join(',') : '';

        const response = await axios.post('/Transactions/PreBooking/List', {
          companyId: sessionStorage.getItem('CompanyId'),
          branchId: branchIdForApi,
          branchIds: branchIdsForApi,
          fromDate: moment(effectiveFilters.fromDate).format('YYYYMMDD'),
          toDate: moment(effectiveFilters.toDate).format('YYYYMMDD'),
          searchBy: effectiveFilters.searchBy,
          searchValue: effectiveFilters.searchValue,
          isDraft: effectiveFilters.isDraft === 'ALL' ? '' : effectiveFilters.isDraft,
          // shipmentType: normalizeShipmentTypeValue(effectiveFilters.shipmentType),
           shipmentType: effectiveFilters.shipmentType,
          bookingStatus: effectiveFilters.bookingStatus === 'ALL' ? '' : effectiveFilters.bookingStatus,
          BranchId: branchIdForApi,
        });
        setRows(response.data || []);
      } catch (error) {
        openSnackBar(error?.response?.data?.message || 'Unable to load pre-bookings', 'error');
      } finally {
        hideLoading();
      }
    },
    [isSalesUser, withoutuser, branchListLoaded, openSnackBar, showLoading, hideLoading]
  );

  // ==================== EFFECTS ====================
  useEffect(() => {
    loadBranchList();
    loadCountryList();
    loadShipperList();
  }, [loadBranchList, loadCountryList, loadShipperList]);

  useEffect(() => {
    loadCustomerList(withoutuser);
  }, [loadCustomerList, withoutuser]);

  useEffect(() => {
    if (!isSalesUser || branchListLoaded) loadList();
  }, [isSalesUser, branchListLoaded, loadList]);

  useEffect(() => {
    if (form.ShipperLinerId) loadShipperCountryList(form.ShipperLinerId);
    else setShipperCountryList([]);
  }, [form.ShipperLinerId, loadShipperCountryList]);

  useEffect(() => {
    loadReceiverList();
  }, [loadReceiverList]);

  useEffect(() => {
    if (form.SenCountryId) getSenderState(form.SenCountryId);
    else setSenderStateList([]);
  }, [form.SenCountryId, getSenderState]);

  useEffect(() => {
    if (form.RecCountryId) getReceiverState(form.RecCountryId);
    else setReceiverStateList([]);
  }, [form.RecCountryId, getReceiverState]);

  useEffect(() => {
    if (!countryList.length) return;
    const originCountry = getOriginCountry(countryList);
    if (!originCountry) return;
    setForm((prev) => {
      if (Number(prev.SenCountryId) === Number(originCountry.CountryId)) return prev;
      return { ...prev, SenCountryId: Number(originCountry.CountryId), SenderCountry: originCountry.CountryName || '' };
    });
    getSenderState(Number(originCountry.CountryId));
  }, [countryList, getOriginCountry, isEditing, isDraftEditing, form.SenCountryId, getSenderState]);

  // ==================== VALIDATION ====================
  const validateForm = ({ includeDetails = false } = {}) => {
    const errs = {};
    if (!form.CustomerId) errs.CustomerId = 'Customer is required';
    if (!form.SenCountryId) errs.SenCountryId = 'Sender Country is required';
    if (!form.RecCountryId) errs.RecCountryId = 'Receiver Country is required';
    if (!form.PreDocType) errs.PreDocType = 'Document Type is required';
    if (!form.Dimension) errs.Dimension = 'Dimension is required';
    if (form.NoOfBox === '' || form.NoOfBox === null || form.NoOfBox === undefined) {
      errs.NoOfBox = 'No of Box is required';
    } else if (Number(form.NoOfBox) < 1) {
      errs.NoOfBox = 'No of Box must be at least 1';
    }
    if (!form.Branch && !form.BranchId) errs.Branch = 'Branch is required';
    if (includeDetails) {
      if (!form.SName?.trim()) errs.SName = 'Sender Name is required';
      if (!form.SContactNo?.trim()) errs.SContactNo = 'Sender Contact No is required';
      if (!form.SAdd1?.trim()) errs.SAdd1 = 'Sender Address Line 1 is required';
      if (!form.RName?.trim()) errs.RName = 'Receiver Name is required';
      if (!form.RContactNo?.trim()) errs.RContactNo = 'Receiver Contact No is required';
      if (!form.RAdd1?.trim()) errs.RAdd1 = 'Receiver Address Line 1 is required';
      if (form.PickupMiles !== '' && form.PickupMiles != null && !isValidNumericInput(form.PickupMiles)) {
        errs.PickupMiles = 'Up to 9 digits, max 2 decimals (e.g. 1234.69)';
      }
      if (form.PickupCharges !== '' && form.PickupCharges != null && !isValidNumericInput(form.PickupCharges)) {
        errs.PickupCharges = 'Up to 9 digits, max 2 decimals (e.g. 1234.69)';
      }
      if (form.Remark && String(form.Remark).length > 150) {
        errs.Remark = 'Remarks cannot exceed 150 characters';
      }
      if (form.Remark && /[^\p{L}\p{N}\s.,\-_/()&'"]/u.test(String(form.Remark))) {
        errs.Remark = 'Only letters, numbers and basic punctuation allowed';
      }
      // if (!form.PrePayMode) errs.PrePayMode = 'Pay Mode is required';
      // if (!form.ShipModeValue) errs.ShipModeValue = 'Ship Mode is required';
      // if (!form.PickupDate) errs.PickupDate = 'Pickup Date is required';
      // if (!form.PickupTime) errs.PickupTime = 'Pickup Time is required';
    }
    const order = [
      'CustomerId',
      'SenCountryId',
      'RecCountryId',
      'PreDocType',
      'Dimension',
      'NoOfBox',
      'Branch',
      'BookingStatus',
      'SName',
      'SContactNo',
      'SAdd1',
      'RName',
      'RContactNo',
      'RAdd1',
      'PickupMiles',
      'PickupCharges',
      'PrePayMode',
      'ShipModeValue',
      'PickupDate',
      'PickupTime',
      'Remark',
    ];
    const firstFieldKey = order.find((k) => errs[k]) || null;
    return { ok: Object.keys(errs).length === 0, errors: errs, firstFieldKey };
  };

  const FIELD_LABELS = {
    CustomerId: 'Customer',
    SenCountryId: 'Sender Country',
    RecCountryId: 'Receiver Country',
    PreDocType: 'Document Type',
    Dimension: 'Dimension',
    NoOfBox: 'No of Box',
    Branch: 'Branch',
    BookingStatus: 'Booking Status',
    SName: 'Sender Name',
    SContactNo: 'Sender Contact No',
    SAdd1: 'Sender Address Line 1',
    RName: 'Receiver Name',
    RContactNo: 'Receiver Contact No',
    RAdd1: 'Receiver Address Line 1',
    PickupMiles: 'Pickup Miles',
    PickupCharges: 'Pickup Charges',
    PrePayMode: 'Pay Mode',
    ShipModeValue: 'Ship Mode',
    PickupDate: 'Pickup Date',
    PickupTime: 'Pickup Time',
    Remark: 'Remarks',
  };

  const applyValidationAndNotify = ({ includeDetails }) => {
    setSubmitAttempted(true);
    const { ok, errors: errs, firstFieldKey } = validateForm({ includeDetails });
    setErrors(errs);
    if (!ok) {
      const label = firstFieldKey ? FIELD_LABELS[firstFieldKey] || firstFieldKey : '';
      const msg = firstFieldKey ? `${label}: ${errs[firstFieldKey]}` : 'Please fill all required fields';
      openSnackBar(msg, 'error');
      if (firstFieldKey) {
        const el = fieldRefs.current[firstFieldKey];
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
    return ok;
  };

  // ==================== FILTER HANDLERS ====================
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleFilterCustomerSelect = (event, value) => {
    if (!value) {
      setFilterCustomerInputValue('');
      setFilters((prev) => ({ ...prev, searchCustomer: null, searchValue: '' }));
      return;
    }
    const searchByField = filters.searchBy || 'phonenumber';
    let searchValue = '';
    if (searchByField === 'phonenumber') searchValue = value.Phone || '';
    else if (searchByField === 'emailid') searchValue = value.EmailId || value.emailId || value.EMAILID || '';
    else searchValue = value.CUSTOMERNAME || value.CustomerName || '';
    setFilterCustomerInputValue(searchValue);
    setFilters((prev) => ({ ...prev, searchCustomer: value, searchValue }));
  };

  const handleFilterSearchByChange = (e) => {
    const newSearchBy = e.target.value;
    setFilterCustomerInputValue('');
    setFilters((prev) => ({
      ...prev,
      searchBy: newSearchBy,
      searchCustomer: null,
      searchValue: '',
    }));
  };

  const searchValueLabel = searchByFilterOptions.find((option) => option.value === filters.searchBy)?.label || 'Value';

  const handleViewFilters = () => {
    if (withoutuser && !filters.searchCustomer) {
      const message = filterCustomerInputValue.trim()
        ? 'Please select a record from the dropdown list'
        : 'Please select a search by Customer Name, Phone Number or Email ID';
      openSnackBar(message, 'warning');
      return;
    }
    loadList(filters);
  };

  const handleResetFilters = () => {
    const nextFilters = { ...DEFAULT_FILTERS };
    setFilterCustomerInputValue('');
    setFilters(nextFilters);
    setPage(0);
    if (withoutuser) {
      setWithoutuser(false);
      loadCustomerList(false);
    }
    loadList(nextFilters, false);
  };

  // ==================== FORM HANDLERS ====================
  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (name === 'PickupMiles' || name === 'PickupCharges') {
      const sanitized = sanitizeNumericInput(value);
      setForm((prev) => ({ ...prev, [name]: sanitized }));
      setErrors((prev) => ({
        ...prev,
        [name]:
          sanitized !== '' && !isValidNumericInput(sanitized)
            ? 'Up to 9 digits, max 2 decimals (e.g. 1234.69)'
            : undefined,
      }));
      return;
    }
    if (name === 'Remark') {
      const sanitized = sanitizeAlphanumeric150(value);
      setForm((prev) => ({ ...prev, Remark: sanitized }));
      setErrors((prev) => ({
        ...prev,
        Remark: sanitized.length > 150 ? 'Remarks cannot exceed 150 characters' : undefined,
      }));
      return;
    }
    setForm((prev) => {
      const nextValue = type === 'checkbox' ? (checked ? 'Y' : 'N') : value;
      const nextForm = { ...prev, [name]: nextValue };
      if (name === 'ShipMode') {
        nextForm.ShipmentTypeValue = value;
        nextForm.ShipMode = getShipmentModeFromValue(value);
        nextForm.ShipperLinerId = 0;
        nextForm.RecCountryId = 0;
        nextForm.ReceiverCountry = '';
        nextForm.RecProvince = '';
        nextForm.RecStateId = 0;
        nextForm.ShipmentTypeLabel = shipmentTypeLabels[value] || nextForm.ShipMode;
      }
      if (name === 'Branch') nextForm.BranchId = Number(value || 0);
      return nextForm;
    });
    if (name === 'ShipMode') setShipperCountryList([]);
    setErrors((prev) => {
      if (!prev[name]) return prev;
      const next = { ...prev };
      delete next[name];
      return next;
    });
  };

  const getCustomerIdValue = (customer) =>
    Number(
      customer?.CUSTOMERID ??
        customer?.customerId ??
        customer?.CustomerId ??
        customer?.CUSTOMER_ID ??
        customer?.customerid ??
        0
    );

  const handleCustomerSelect = (event, value) => {
    if (!value) {
      setSelectedCustomer(null);
      setForm((prev) => ({ ...prev, CustomerId: 0 }));
      return;
    }
    const customerId = getCustomerIdValue(value);
    setSelectedCustomer(value);
    setForm((prev) => ({ ...prev, CustomerId: customerId }));
    setErrors((prev) => {
      const next = { ...prev };
      delete next.CustomerId;
      return next;
    });
  };

  const handleSameAsCustomerToggle = async (event) => {
    const isChecked = event.target.checked;
    if (!isChecked) {
      setForm((prev) => ({
        ...prev,
        SameAsCustomer: 'N',
        SName: '',
        SContactNo: '',
        SEmailId: '',
        SAdd1: '',
        SAdd2: '',
        SAdd3: '',
        SCity: '',
        SAtlNo: '',
        Senpincode: '',
        SenStateId: 0,
        SenProvince: '',
        PickupAddress: '',
        PostalCode: '',
      }));
      return;
    }
    const customerId = Number(form.CustomerId || 0);
    if (!customerId) return;
    try {
      const response = await axios.get(`/Transactions/Courier/GetSameAsAddress/${customerId}`);
      const senderData = Array.isArray(response.data) ? response.data[0] : response.data;
      if (!senderData) return;

      const originCountry = getOriginCountry(countryList);
      const originCountryId = Number(originCountry?.CountryId || form.SenCountryId || 0);
      const customerCountryId = Number(senderData.CusCountryId || 0);
      if (customerCountryId && originCountryId && customerCountryId !== originCountryId) {
        const customerCountry = countryList.find((country) => Number(country.CountryId) === customerCountryId);
        const selectedCountry = countryList.find((country) => Number(country.CountryId) === originCountryId);
        setCustomerMismatchMessage(
          `There is a mismatch between the sender's country as selected (${selectedCountry?.CountryName || originCountry?.CountryName || originCountryId}) 
            and the one recorded in the customer record (${customerCountry?.CountryName || customerCountryId}). Please review and update the country as necessary.`
        );
        setCustomerMismatchOpen(true);
        return;
      }

      const senderCountryId = customerCountryId || originCountryId;
      const senderStateId = Number(senderData.CusstateId ?? senderData.StateId ?? 0);
      let senderState = {};
      try{
      const stateResponse = senderCountryId ? await axios.get(`/signup/GetAllState/${senderCountryId}`) : { data: [] };
       senderState = (stateResponse.data || []).find((state) => Number(state.StateId) === senderStateId);
       } catch {
              console.log('error');
            }
      const senderAddress1 = senderData.Address1 || '';
      const senderAddress2 = senderData.Address2 || '';
      const senderAddress3 = senderData.Address3 || '';
      const senderPincode = senderData.Zipcode || senderData.Pincode || senderData.PINCODE || '';
      const fullSenderAddress = [senderAddress1, senderAddress2, senderAddress3]
        .map((line) => String(line || '').trim())
        .filter(Boolean)
        .join(', ');

      setForm((prev) => ({
        ...prev,
        SameAsCustomer: 'Y',
        SName: senderData.CustomerName || '',
        SContactNo: senderData.Phone || '',
        SAtlNo: senderData.AlterPhone || '',
        SEmailId: senderData.EmailId || '',
        SAdd1: senderAddress1,
        SAdd2: senderAddress2,
        SAdd3: senderAddress3,
        SCity: senderData.City || '',
        Senpincode: senderPincode,
        SenCountryId: senderCountryId || prev.SenCountryId,
        SenderCountry: originCountry?.CountryName || prev.SenderCountry,
        SenStateId: senderState?.StateId || senderStateId,
        SenProvince: senderState?.StateName || '',
        PickupAddress: fullSenderAddress || prev.PickupAddress,
        PostalCode: senderPincode || prev.PostalCode,
      }));
      setErrors((prev) => {
        const next = { ...prev };
        ['SName', 'SContactNo', 'SAdd1'].forEach((key) => delete next[key]);
        return next;
      });
      if (senderCountryId) getSenderState(senderCountryId);
    } catch (error) {
      console.log(error,'error')
      openSnackBar('Unable to load customer address', 'error');
    }
  };

  const handleShipperSelect = async (event, value) => {
    if (value) {
      const shipperId = Number(value.AgentId ?? value.ShipperLinerId ?? value.shipperlinerid ?? 0);
      setForm((prev) => ({
        ...prev,
        ShipperLinerId: shipperId,
        RecCountryId: 0,
        ReceiverCountry: '',
        RecProvince: '',
        RecStateId: 0,
      }));
      await loadShipperCountryList(shipperId);
    } else {
      setForm((prev) => ({
        ...prev,
        ShipperLinerId: 0,
        RecCountryId: 0,
        ReceiverCountry: '',
        RecProvince: '',
        RecStateId: 0,
      }));
      setShipperCountryList([]);
    }
  };

  const resetForm = () => {
    const originCountry = getOriginCountry(countryList);
    handleResetFilters();
    setForm({
      ...initialForm,
      CompanyId: Number(sessionStorage.getItem('CompanyId') || 0),
      BranchId: Number(sessionStorage.getItem('BranchId') || 0),
      PreBookDate: moment().format('YYYY-MM-DD'),
      SenCountryId: Number(originCountry?.CountryId || 0),
      SenderCountry: originCountry?.CountryName || '',
      PickupDate: moment().format('YYYY-MM-DD'),
      PickupTime: '00:00',
    });
    setSelectedCustomer(null);
    setIsEditing(false);
    setShowBookingDetails(false);
    setErrors({});
    setSubmitAttempted(false);
  };

  const handleStartBooking = () => {
    const ok = applyValidationAndNotify({ includeDetails: false });
    if (!ok) return;
    setShowBookingDetails(true);
  };

  const handleCloseFromBasicDetails = () => {
    if (window.confirm('Close without saving? Any unsaved changes will be lost.')) handleCloseDialog();
  };

  const handleSubmit = async (saveAsDraft = false) => {
    if (!saveAsDraft) {
      const ok = applyValidationAndNotify({ includeDetails: true });
      if (!ok) return;
      if (!showBookingDetails) {
        setShowBookingDetails(true);
        return;
      }
    } else {
      setErrors({});
    }
    try {
      showLoading();
      const effectivePickupDate = form.PickupDate || form.PreBookDate || moment().format('YYYY-MM-DD');
      const effectivePickupTime = form.PickupTime || '00:00';
      const numericPickupMiles = form.PickupMiles === '' ? 0 : Number(form.PickupMiles || 0);
      const numericPickupCharges = form.PickupCharges === '' ? 0 : Number(form.PickupCharges || 0);
      const originCountry = getOriginCountry(countryList);
      const currentPreBookDate = moment().format('YYYY-MM-DD');
      const payload = {
        PreBookOrderId: Number(form.PreBookOrderId || 0),
        PreBookOrderNo: form.PreBookOrderNo || '',
        PreBookDate: form.IsDraft === 'Y' && !saveAsDraft ? currentPreBookDate : form.PreBookDate,
        CompanyId: Number(sessionStorage.getItem('CompanyId') || 0),
        BranchId: Number(form.BranchId || sessionStorage.getItem('BranchId') || 0),
        CustomerId: Number(form.CustomerId || 0),
        ShipperLinerId: Number(form.ShipperLinerId || 0),
        CountryId: Number(form.RecCountryId || 0),
        SourceId: Number(form.SourceId || 0),
        shipmentType: form.ShipMode,
        ShipmentTypeValue: form.ShipmentTypeValue || '',
        ShipMode: form.ShipMode,
        PreDocType: form.PreDocType || '',
        Dimension: form.Dimension || '',
        NoOfBox: Number(form.NoOfBox || 1),
        IntoBooking: String(form.IntoBooking || 'N').toUpperCase(),
        ParcelCollected: String(form.IntoBooking || 'N').toUpperCase(),
        SameAsCustomer: form.SameAsCustomer || 'N',
        SName: form.SName || '',
        SContactNo: form.SContactNo || '',
        SAtlNo: form.SAtlNo || '',
        SEmailId: form.SEmailId || '',
        SAdd1: form.SAdd1 || '',
        SAdd2: form.SAdd2 || '',
        SAdd3: form.SAdd3 || '',
        SCity: form.SCity || '',
        SCountry: form.SCountry || form.SenderCountry || '',
        SenderCountry: originCountry?.CountryName || form.SenderCountry || '',
        SenCountryId: Number(originCountry?.CountryId || form.SenCountryId || 0),
        SenProvince: form.SenProvince || '',
        SenStateId: Number(form.SenStateId || 0),
        Senpincode: form.Senpincode || '',
        RName: form.RName || '',
        RContactNo: form.RContactNo || '',
        RAtlNo: form.RAtlNo || '',
        REmailId: form.REmailId || '',
        RAdd1: form.RAdd1 || '',
        RAdd2: form.RAdd2 || '',
        RAdd3: form.RAdd3 || '',
        RCity: form.RCity || '',
        RCountry: form.RCountry || form.ReceiverCountry || '',
        ReceiverCountry: form.ReceiverCountry || '',
        RecCountryId: Number(form.RecCountryId || 0),
        RecProvince: form.RecProvince || '',
        RecStateId: Number(form.RecStateId || 0),
        RecPincode: form.RecPincode || '',
        Branch: form.Branch || '',
        PrePayMode: form.PrePayMode || '',
        ShipModeValue: form.ShipModeValue || '',
        BookingStatus: form.BookingStatus || form.Status || '',
        Status: form.Status || form.BookingStatus || '',
        IsDraft: saveAsDraft ? 'Y' : 'N',
        PickupMiles: numericPickupMiles,
        PickupCharges: numericPickupCharges,
        PickupReqd: Number(form.PickupBranchId || 0) > 0 ? 'Y' : 'N',
        PickupAddress: form.PickupAddress || '',
        PickupBranch: form.PickupBranch || '',
        PickupBranchId: Number(form.PickupBranchId || 0),
        PickupDate: effectivePickupDate,
        PickupTime: effectivePickupTime,
        PostalCode: form.PostalCode || '',
        Remark: form.Remark || '',
        FiscalYear: form.FiscalYear || '',
        SatlNo: form.SAtlNo || form.SatlNo || '',
        RatlNo: form.RAtlNo || form.RatlNo || '',
        SenCntryCode: form.SenCntryCode || '',
        RecCntryCode: form.RecCntryCode || '',
        PreZoneId: Number(form.PreZoneId || 0),
        CreatedBy: Number(sessionStorage.getItem('UserId') || 0),
        ModifiedBy: Number(sessionStorage.getItem('UserId') || 0),
        Createdon: new Date(),
        ModifiedOn: new Date(),
        OpType: isEditing ? 'Edit' : 'New',
      };
      const response = await axios.post('/Transactions/PreBooking/Save', payload);
      const savedId = Number(response.data?.PreBookOrderId || payload.PreBookOrderId || 0);
      if (saveAsDraft) {
        setForm((prev) => ({ ...prev, PreBookOrderId: savedId, IsDraft: 'Y' }));
        setIsEditing(true);
        openSnackBar('Pre-booking draft saved successfully', 'success');
        handleCloseDialog();
      } else {
        openSnackBar(isEditing ? 'Pre-booking updated successfully' : 'Pre-booking created successfully', 'success');
        setDialogOpenState(false);
        resetForm();
      }
      await loadList(filters);
    } catch (error) {
      openSnackBar(error?.response?.data?.message || 'Unable to save pre-booking', 'error');
    } finally {
      hideLoading();
    }
  };

  const openPreBookingDetails = async (record, mode = 'view') => {
    try {
      showLoading();
      const shipmentType = getRecordShipmentMode(record);
      const response = await axios.get(
        `/Transactions/PreBooking/Get/${record.PreBookOrderId}?shipmentType=${shipmentType}`
      );
      const data = response.data || {};
      const savedShipmentTypeValue = getSavedShipmentTypeValue(data);
      const preBookOrderId = Number(
        data.PreBookOrderId ?? data.prebookorderid ?? data.preBookOrderId ?? record.PreBookOrderId ?? 0
      );
       const savedCustomerId = Number(data.CustomerId ?? data.customerid ?? data.customerId ?? 0);
      const savedCustomer = {
        ...data,
        CUSTOMERID: savedCustomerId,
        CUSTOMERNAME: data.CUSTOMERNAME || data.CustomerName || data.customerName || data.SName || '',
        Phone: data.Phone || data.CustomerPhone || data.customerPhone || data.SContactNo || '',
        EmailId: data.EmailId || data.CustomerEmailId || data.customerEmailId || data.SEmailId || '',
      };
      setSelectedCustomer(savedCustomerId ? savedCustomer : null);

      const originCountry = getOriginCountry(countryList);
      const effectiveSenCountryId = Number(originCountry?.CountryId || data.SenCountryId || 0);
      const effectiveSenCountryName =
        originCountry?.CountryName ||
        data.SenderCountry ||
        countryList.find((c) => Number(c.CountryId) === effectiveSenCountryId)?.CountryName ||
        '';

      const savedPickupMiles = data.PickupMiles ?? data.pickupMiles ?? 0;
      const savedPickupCharges = data.PickupCharges ?? data.pickupCharges ?? 0;
      const displayPickupMiles =
        savedPickupMiles === 0 || savedPickupMiles === '0' || savedPickupMiles === null ? '' : String(savedPickupMiles);
      const displayPickupCharges =
        savedPickupCharges === 0 || savedPickupCharges === '0' || savedPickupCharges === null
          ? ''
          : String(savedPickupCharges);
      const savedPickupDate = data.PickupDate ? moment.utc(data.PickupDate).format('YYYY-MM-DD') : '';
      const savedPickupTime = data.PickupTime ? moment.utc(data.PickupTime).format('HH:mm') : '';

      setForm({
        ...initialForm,
        ...data,
        SAtlNo: data.SAtlNo ?? data.SatlNo ?? data.satlNo ?? '',
        RAtlNo: data.RAtlNo ?? data.RatlNo ?? data.ratlNo ?? '',
        PreBookOrderId: preBookOrderId,
        IsBooked: data.IsBooked ?? data.isBooked ?? record.IsBooked ?? record.isBooked ?? 'N',
        IsBookedWeb: data.IsBookedWeb ?? data.isBookedWeb ?? record.IsBookedWeb ?? record.isBookedWeb ?? 'N',
        CustomerId: savedCustomerId,
        searchByField: data.searchByField || 'phonenumber',
        CompanyId: Number(data.CompanyId || sessionStorage.getItem('CompanyId') || 0),
        BranchId: Number(data.BranchId || sessionStorage.getItem('BranchId') || 0),
        Branch: data.BranchId ? String(data.BranchId) : '',
        SenCountryId: effectiveSenCountryId,
        SenderCountry: effectiveSenCountryName,
        ReceiverCountry: data.RCountry || data.ReceiverCountry || '',
        PreBookDate: data.PreBookDate ? moment.utc(data.PreBookDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        PickupDate: savedPickupDate || moment().format('YYYY-MM-DD'),
        PickupTime: savedPickupTime || '00:00',
        ShipMode: getShipmentModeFromValue(savedShipmentTypeValue),
        ShipmentTypeValue: savedShipmentTypeValue,
        ShipModeValue: data.ShipModeValue || data.shipModeValue || data.ShipMode || 'Air',
        IntoBooking: String(data.IntoBooking || 'N').toUpperCase(),
        BookingStatus: data.BookingStatus || data.Status || '',
        Status: data.Status || data.BookingStatus || '',
        IsDraft: String(data.IsDraft ?? data.isDraft ?? 'N').toUpperCase(),
        NoOfBox: Number(data.NoOfBox || 1),
        PickupMiles: displayPickupMiles,
        PickupCharges: displayPickupCharges,
      });
      setErrors({});
      setSubmitAttempted(false);
      setIsEditing(mode === 'edit');
      setShowBookingDetails(true);
      setDialogOpenState(true);
    } catch (error) {
      openSnackBar('Unable to fetch pre-booking details', 'error');
    } finally {
      hideLoading();
    }
  };

  const handleEdit = async (record) => {
    await openPreBookingDetails(record, 'edit');
  };
  const handleDelete = (record) => {
    setPreBookingToDelete(record);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = async () => {
    const record = preBookingToDelete;
    setDeleteDialogOpen(false);
    setPreBookingToDelete(null);
    if (!record) return;
    try {
      showLoading();
      await axios.delete(`/Transactions/PreBooking/Delete/${record.PreBookOrderId}`, {
        data: { shipmentType: getRecordShipmentMode(record) || form.ShipMode || 'courier' },
      });
      openSnackBar('Pre-booking deleted successfully', 'success');
      loadList(filters);
      if (isEditing && form.PreBookOrderId === record.PreBookOrderId) resetForm();
    } catch (error) {
      openSnackBar(error?.response?.data?.message || 'Unable to delete pre-booking', 'error');
    } finally {
      hideLoading();
    }
  };

  const handleOpenAddDialog = () => {
    const shipmentOptions = origin === 'IN'
      ? shipmentTypeOptionsIN
      : origin === 'UK'
      ? shipmentTypeOptionsUK
      : shipmentTypeOptionsSL;
    handleProceed(shipmentOptions[0].value, shipmentOptions[0].label);
  };

  const handleProceed = (value, label) => {
    const shipmentValue = value || getDefaultShipmentTypeValue();
    const normalizedValue = getShipmentModeFromValue(shipmentValue);
    setSelectedShipment(label || normalizedValue);
    setSelectedCustomer(null);
    const originCountry = getOriginCountry(countryList);
    setForm({
      ...initialForm,
      CompanyId: Number(sessionStorage.getItem('CompanyId') || 0),
      BranchId: Number(sessionStorage.getItem('BranchId') || 0),
      PreBookDate: moment().format('YYYY-MM-DD'),
      ShipMode: normalizedValue,
      ShipmentTypeValue: shipmentValue,
      ShipmentTypeLabel: label || normalizedValue,
      SenCountryId: Number(originCountry?.CountryId || 0),
      SenderCountry: originCountry?.CountryName || '',
      PickupDate: moment().format('YYYY-MM-DD'),
      PickupTime: '00:00',
    });
    setErrors({});
    setSubmitAttempted(false);
    setShowBookingDetails(false);
    setDialogOpenState(true);
  };

  const handleCloseDialog = () => {
    setDialogOpenState(false);
    setSelectedShipment('');
    
    resetForm();
  };

  const paginatedRows = useMemo(() => {
    const start = page * rowsPerPage;
    return rows.slice(start, start + rowsPerPage);
  }, [rows, page, rowsPerPage]);

  if (!['Sales', 'Admin'].includes(userRole)) {
    return <Navigate to="/dashboard/home" replace />;
  }

  // ==================== RENDER ====================
  return (
    <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
      {/* ===== PAGE HEADER ===== */}
      <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
        <Typography
          variant="h5"
          p={1}
          textAlign={'center'}
          borderRadius={2}
          pl={2}
          color="white"
          sx={{
            background: '#8EACCD',
            boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
          }}
        >
          <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
            Pre-Booking
          </Typography>
        </Typography>
      </Grid>

      {/* ===== FILTERS ===== */}
      <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
        <Accordion
          expanded={isFilterExpanded}
          onChange={() => setFilterExpanded((v) => !v)}
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: '#8EACCD' }} />} sx={{ borderTop: 'none' }}>
            <Stack direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton color="#8EACCD">
                <FilterAltIcon style={{ color: '#8EACCD', width: 24, height: 24 }} />
              </IconButton>
              <Typography sx={{ color: '#8EACCD' }} variant="h6">
                Filters
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
            <Grid container spacing={2} p={1} pt={0} mb={0.5} rowSpacing={2} columnSpacing={1}>
              {/* All Customers Checkbox */}
              {isSalesUser && (
                <Grid item md={0.75} xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Tooltip title={withoutuser ? 'Showing all customers' : 'Showing my customers only'}>
                    <label className="prebooking-customer-scope" htmlFor="prebooking-customer-scope-checkbox">
                      <input
                        id="prebooking-customer-scope-checkbox"
                        className="prebooking-customer-scope__input"
                        type="checkbox"
                        checked={withoutuser}
                        onChange={handleWithoutUserToggle}
                        aria-label="Toggle all customer scope"
                      />
                      <span className="prebooking-customer-scope__box">
                        <svg aria-hidden="true" viewBox="0 0 28 28">
                          <path d="M4 14l8 7L24 7" />
                        </svg>
                      </span>
                    </label>
                  </Tooltip>
                  <style>{`
                    .prebooking-customer-scope {
                      --scope-primary: #257180;
                      --scope-primary-soft: rgb(37 113 128 / 20%);
                      --scope-primary-subtle: rgb(37 113 128 / 10%);
                      position: relative;
                      display: inline-flex;
                      align-items: center;
                      cursor: pointer;
                    }

                    .prebooking-customer-scope__input {
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      margin: -1px;
                      overflow: hidden;
                      clip: rect(0 0 0 0);
                      white-space: nowrap;
                    }

                    .prebooking-customer-scope__box {
                      display: flex;
                      width: 1.5em;
                      height: 1.5em;
                      border: 1px solid var(--scope-primary);
                      border-radius: 3px;
                      box-shadow: 0 0 0 0 var(--scope-primary-subtle);
                      transition: box-shadow 0.2s ease, background-color 0.2s ease;
                    }

                    .prebooking-customer-scope__box:after {
                      position: absolute;
                      top: 0.625em;
                      left: 0.625em;
                      width: 0.25em;
                      height: 0.25em;
                      border-radius: 50%;
                      background: var(--scope-primary-soft);
                      content: '';
                      opacity: 0;
                    }

                    .prebooking-customer-scope__box svg {
                      width: 1em;
                      height: 1em;
                      margin: auto;
                      fill: none;
                      stroke: var(--scope-primary);
                      stroke-width: 3;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    }

                    .prebooking-customer-scope__box path {
                      stroke-dasharray: 30px, 31px;
                      stroke-dashoffset: 31px;
                      transition: stroke-dashoffset 0.2s ease;
                    }

                    .prebooking-customer-scope__input:checked + .prebooking-customer-scope__box path {
                      stroke-dashoffset: 0;
                    }

                    .prebooking-customer-scope__input:checked + .prebooking-customer-scope__box:after {
                      animation: prebooking-scope-ripple 0.6s ease-out;
                    }

                    .prebooking-customer-scope__input:focus-visible + .prebooking-customer-scope__box {
                      box-shadow: 0 0 0 0.25em var(--scope-primary-soft);
                    }

                    @keyframes prebooking-scope-ripple {
                      to {
                        opacity: 0;
                        transform: scale(8);
                      }
                    }
                  `}</style>
                </Grid>
              )}

              {/* Search By */}
              <Grid item md={2.25} xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Search by"
                  name="searchBy"
                  value={filters.searchBy}
                  onChange={handleFilterSearchByChange}
                  variant="outlined"
                  size="small"
                >
                  {searchByFilterOptions.map((o) => (
                    <MenuItem key={o.value} value={o.value}>
                      {o.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Search Value */}
              <Grid item md={3} xs={12}>
                <Autocomplete
                  key={`filter-customer-${filters.searchBy}-${withoutuser ? 'all' : 'mine'}`}
                  options={filters.searchBy ? customerList : []}
                  getOptionLabel={(customer) => {
                    if (!customer) return '';
                    if (filters.searchBy === 'phonenumber') return customer.Phone || '';
                    if (filters.searchBy === 'emailid')
                      return customer.EmailId || customer.emailId || customer.EMAILID || '';
                    return customer.CUSTOMERNAME || customer.CustomerName || '';
                  }}
                  renderOption={(props, customer) => (
                    <li {...props} key={getCustomerIdValue(customer)}>
                      {filters.searchBy === 'phonenumber'
                        ? customer.Phone || ''
                        : filters.searchBy === 'emailid'
                        ? customer.EmailId || customer.emailId || customer.EMAILID || ''
                        : customer.CUSTOMERNAME || customer.CustomerName || ''}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => getCustomerIdValue(option) === getCustomerIdValue(value)}
                  value={filters.searchCustomer || null}
                  inputValue={filterCustomerInputValue}
                  onChange={handleFilterCustomerSelect}
                  onInputChange={(event, value, reason) => {
                    setFilterCustomerInputValue(value);
                    if (reason === 'input' || reason === 'clear') {
                      setFilters((prev) => ({ ...prev, searchCustomer: null, searchValue: '' }));
                    }
                  }}
                  size="small"
                  disabled={!filters.searchBy}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={`Search ${searchValueLabel}`}
                      placeholder={filters.searchBy ? `Select ${searchValueLabel.toLowerCase()}` : 'Select Search By first'}
                    />
                  )}
                />
              </Grid>

              {/* Shipment Type */}
              <Grid item md={3} xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Shipment Type"
                  name="shipmentType"
                  value={filters.shipmentType}
                  onChange={handleFilterChange}
                  variant="outlined"
                  size="small"
                >
                  {shipmentTypeFilterOptions.map((o) => (
                    <MenuItem key={o.value} value={o.value}>
                      {o.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* From Date */}
              <Grid item md={1.5} xs={12}>
                <TextField
                  fullWidth
                  label="From Date"
                  type="date"
                  name="fromDate"
                  value={filters.fromDate}
                  onChange={handleFilterChange}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  size="small"
                  inputProps={{ max: '9999-12-31' }}
                />
              </Grid>

              {/* To Date */}
              <Grid item md={1.5} xs={12}>
                <TextField
                  fullWidth
                  label="To Date"
                  type="date"
                  name="toDate"
                  value={filters.toDate}
                  onChange={handleFilterChange}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  size="small"
                  inputProps={{ max: '9999-12-31' }}
                />
              </Grid>

              {/* Branch */}
              <Grid item md={isSalesUser ? 2.5 : 3} xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Branch"
                  name="branch"
                  value={
                    filters.branch === null ? 'ALL' : filters.branch === '' ? 'ALL' : filters.branch?.BranchId || 'ALL'
                  }
                  onChange={(e) => {
                    const v = e.target.value;
                    if (v === 'ALL') {
                      setFilters((prev) => ({ ...prev, branch: 'ALL' }));
                    } else {
                      const selected = branchList.find((b) => Number(b.BranchId) === Number(v));
                      setFilters((prev) => ({ ...prev, branch: selected || 'ALL' }));
                    }
                  }}
                  variant="outlined"
                  size="small"
                >
                  <MenuItem value="ALL">All</MenuItem>
                  {branchList.map((b) => (
                    <MenuItem key={b.BranchId} value={b.BranchId}>
                      {b.BranchName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Booking Status */}
              <Grid item md={isSalesUser ? 2.5 : 3} xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Booking Status"
                  name="bookingStatus"
                  value={filters.bookingStatus}
                  onChange={handleFilterChange}
                  variant="outlined"
                  size="small"
                >
                  {bookingStatusFilterOptions.map((o) => (
                    <MenuItem key={o.value} value={o.value}>
                      {o.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Draft toggle */}
              <Grid item md={2} xs={6} sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    bgcolor: filters.isDraft === 'Y' ? '#eff6ff' : '#f8fafc',
                    borderRadius: '8px',
                    px: 0.75,
                    py: 0.75,
                    border: `1px solid ${filters.isDraft === 'Y' ? '#3b82f6' : '#e2e8f0'}`,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      borderColor: filters.isDraft === 'Y' ? '#2563eb' : '#cbd5e1',
                      boxShadow:
                        filters.isDraft === 'Y'
                          ? '0 0 0 2px rgba(59, 130, 246, 0.1)'
                          : '0 0 0 2px rgba(203, 213, 225, 0.1)',
                    },
                  }}
                >
                  <Box
                    role="switch"
                    aria-label="View draft pre-bookings"
                    aria-checked={filters.isDraft === 'Y'}
                    tabIndex={0}
                    onClick={() => {
                      const nextViewDraft = filters.isDraft !== 'Y';
                      setFilters((prev) => ({ ...prev, isDraft: nextViewDraft ? 'Y' : 'N' }));
                      setRows([]);
                      setPage(0);
                    }}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        const nextViewDraft = filters.isDraft !== 'Y';
                        setFilters((prev) => ({ ...prev, isDraft: nextViewDraft ? 'Y' : 'N' }));
                        setRows([]);
                        setPage(0);
                      }
                    }}
                    sx={{
                      position: 'relative',
                      width: 42,
                      height: 24,
                      borderRadius: '12px',
                      bgcolor: filters.isDraft === 'Y' ? '#3b82f6' : '#94a3b8',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      overflow: 'hidden',
                      flexShrink: 0,
                      '&:before': {
                        content: '""',
                        position: 'absolute',
                        top: 2,
                        left: filters.isDraft === 'Y' ? 20 : 2,
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        bgcolor: 'white',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
                      },
                      '&:after': {
                        content: '""',
                        position: 'absolute',
                        top: '50%',
                        left: filters.isDraft === 'Y' ? 6 : 24,
                        transform: 'translateY(-50%)',
                        width: 8,
                        height: 8,
                        backgroundImage:
                          filters.isDraft === 'Y'
                            ? 'radial-gradient(circle, #60a5fa 1px, transparent 1px)'
                            : 'radial-gradient(circle, #cbd5e1 1px, transparent 1px)',
                        backgroundSize: '3px 3px',
                        opacity: 0.5,
                        transition: 'all 0.2s ease',
                      },
                    }}
                  />

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 80 }}>
                    <Box
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: '5px',
                        bgcolor: filters.isDraft === 'Y' ? '#dbeafe' : '#f1f5f9',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: `1px solid ${filters.isDraft === 'Y' ? '#bfdbfe' : '#e2e8f0'}`,
                      }}
                    >
                      <span
                        style={{
                          fontSize: 13,
                          color: filters.isDraft === 'Y' ? '#3b82f6' : '#64748b',
                        }}
                      >
                        📝
                      </span>
                    </Box>
                    <Typography
                      variant="body2"
                      fontWeight="500"
                      color={filters.isDraft === 'Y' ? '#1e40af' : '#475569'}
                    >
                      Draft
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Buttons: View + Reset */}
              <Grid item xs={6} md={isSalesUser ? 1.25 : 1.5}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleViewFilters}
                  fullWidth
                  sx={{ boxShadow: 0 }}
                >
                  View
                </Button>
              </Grid>
              <Grid item xs={6} md={isSalesUser ? 1.25 : 1.5}>
                <Button
                  variant="contained"
                  color="warning"
                  onClick={handleResetFilters}
                  fullWidth
                  startIcon={<RestartAltIcon fontSize="small" />}
                  sx={{ whiteSpace: 'nowrap' }}
                >
                  Reset
                </Button>
              </Grid>

              {/* New Pre-Booking */}
              {isSalesUser && (
                <Grid item md={2.5} xs={12}>
                  <Button
                    variant="contained"
                    fullWidth
                    endIcon={<LocalShippingIcon style={{ color: 'white' }} />}
                    sx={{ whiteSpace: 'nowrap', boxShadow: 0, bgcolor: '#003161' }}
                    onClick={handleOpenAddDialog}
                  >
                    New Pre-Booking
                  </Button>
                </Grid>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Stack>

      {/* ===== TABLE ===== */}
      <Collapse in={rows.length > 0}>
        <>
          <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
            <Table size="small" stickyHeader sx={{ '& td, & th': { borderBottom: '1px solid #e0e0e0' } }}>
              <TableHead>
                <TableRow>
                    <StyledTableCell align="left">
                    S.No
                  </StyledTableCell>
                  <StyledTableCell align="left" >
                    Pre-Booking No
                  </StyledTableCell>
                    <StyledTableCell align="left" >
                    Pre-Booking Date
                  </StyledTableCell>
                    <StyledTableCell align="left" >
                    Branch
                  </StyledTableCell>
                  <StyledTableCell align="left">Ledger Details</StyledTableCell>
                  <StyledTableCell align="center" sx={{ width: 110 }}>
                    Type
                  </StyledTableCell>
                  <StyledTableCell align="center" sx={{ width: 170 }}>
                    Sender → Receiver
                  </StyledTableCell>
                  <StyledTableCell align="center" sx={{ width: 140 }}>
                    Booking Status
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Raised By
                  </StyledTableCell>
                  <StyledTableCell align="center" sx={{ position: 'sticky', right: 0, zIndex: 2, width: 130 }}>
                    Actions
                  </StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {paginatedRows.map((data, i) => {
                  const isDraft =
                    String(data.IsDraft ?? data.isDraft ?? 'N')
                      .trim()
                      .toUpperCase() === 'Y';
                  const isBookedInWindowsRow =
                    String(data.IsBooked ?? data.isBooked ?? '').trim().toUpperCase() === 'Y';
                  const isBookedInWebRow =
                    String(data.IsBookedWeb ?? data.isBookedWeb ?? '').trim().toUpperCase() === 'Y';
                  const status = normalizeBookingStatus(data.Status ?? data.status ?? '');
                  const rowBackground = isDraft ? '#fff3cd' : getStatusRowBackground(status);

                  const senderCountry =
                    data.SenderCountry ||
                    data.SCountry ||
                    data.SenderCountryName ||
                    data.SenCountryName ||
                    data.SenCountryId ||
                    '-';
                  const receiverCountry =
                    data.ReceiverCountry ||
                    data.RCountry ||
                    data.ReceiverCountryName ||
                    data.RecCountryName ||
                    data.RecCountryId ||
                    '-';
                  const shipmentTypeValue = String(data.ShipmentTypeValue || data.shipmentTypeValue || '')
                    .trim()
                    .toUpperCase();
                  const shipmentLabel =
                    // shipmentTypeLabels[shipmentTypeValue] ||
                    (String(data.ShipmentType || '').toLowerCase() === 'courier'
                      ? 'Air-Cargo'
                      : String(data.ShipmentType || '').toLowerCase() === 'cargo'
                      ? 'Sea-Cargo'
                      : '-');

                  return (
                    <TableRow
                      key={`${data.PreBookOrderId}-${data.ShipmentType || data.ShipMode}`}
                      hover
                      sx={{ backgroundColor: rowBackground }}
                    >
                       <StyledBodyCell align="center">                     
                              {page * rowsPerPage + (i + 1)}      
                       </StyledBodyCell>
                      <StyledBodyCell align="center">
                    
                          <Typography variant="body2" fontWeight={700} sx={{ color: '#11235A' }}>
                              {data.PreBookOrderNo || '-'}
                            </Typography>
                            {(isDraft || isBookedInWindowsRow || isBookedInWebRow) && (
                              <Stack direction="row" spacing={0.5} justifyContent="center" flexWrap="wrap" useFlexGap>
                                {isDraft && (
                                  <Chip
                                    label="Draft"
                                    size="small"
                                    color="warning"
                                    sx={{ height: 18, fontSize: '0.62rem' }}
                                  />
                                )}
                                {isBookedInWindowsRow && (
                                  <Chip
                                    label="Booked in Windows"
                                    size="small"
                                    color="warning"
                                    variant="outlined"
                                    sx={{ height: 18, fontSize: '0.62rem' }}
                                  />
                                )}
                                {isBookedInWebRow && (
                                  <Chip
                                    label="Booked in Web"
                                    size="small"
                                    color="info"
                                    variant="outlined"
                                    sx={{ height: 18, fontSize: '0.62rem' }}
                                  />
                                )}
                              </Stack>
                            )}
                      
                      </StyledBodyCell>
                       <StyledBodyCell align="center"> 
                          {data.PreBookDate ? moment(data.PreBookDate).format('DD/MM/YYYY') : '-'}
                         </StyledBodyCell>
                        <StyledBodyCell align="center">
                                 {data.BranchName ||
                                branchList.find((b) => Number(b.BranchId) === Number(data.BranchId))?.BranchName ||
                                data.BranchId ||
                                '-'}
                           </StyledBodyCell>

                      <StyledBodyCell align="left">
                        <Stack spacing={0.25}>
                          <Stack direction="row" spacing={0.5} alignItems="center">
                            <PortraitIcon sx={{ fontSize: 14 }} color="primary" />
                            <Typography variant="body2" noWrap sx={{ maxWidth: 240 }}>
                              {data.CustomerName || '-'}
                            </Typography>
                          </Stack>
                          <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap">
                            {data.CustomerPhone && (
                              <>
                                <Phone sx={{ fontSize: 12 }} color="success" />
                                <Typography variant="caption">{data.CustomerPhone}</Typography>
                              </>
                            )}
                            {data.CustomerEmailId && (
                              <>
                                <Email sx={{ fontSize: 12 }} color="error" />
                                <Typography variant="caption" sx={{ textTransform: 'lowercase' }}>
                                  {data.CustomerEmailId}
                                </Typography>
                              </>
                            )}
                          </Stack>
                        </Stack>
                      </StyledBodyCell>

                      <StyledBodyCell align="center">
                        <Stack alignItems="center" spacing={0.25}>
                          <Chip
                            label={shipmentLabel}
                            size="small"
                            sx={{
                              height: 18,
                              fontSize: '0.62rem',
                              bgcolor: shipmentLabel === 'Sea-Cargo' ? '#e0f2f1' : '#e3f2fd',
                              color: shipmentLabel === 'Sea-Cargo' ? '#00695c' : '#0d47a1',
                            }}
                          />
                         
                        </Stack>
                      </StyledBodyCell>

                      <StyledBodyCell align="center">
                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
                          <Typography variant="caption" sx={{ color: '#555' }}>
                            {senderCountry}
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#999' }}>
                            →
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#555' }}>
                            {receiverCountry}
                          </Typography>
                        </Stack>
                      </StyledBodyCell>

                      <StyledBodyCell align="center">
                        {isDraft ? (
                          <Chip label="Draft" size="small" color="warning" />
                        ) : status === 'CA' ? (
                          <Chip label="Cancelled" size="small" color="error" />
                        ) : status === 'PO' ? (
                          <Chip label="Postponed" size="small" color="warning" />
                        ) : status === 'PC' ? (
                          <Chip label="Parcel Collected" size="small" color="success" />
                        ) : (
                          <Chip label="Select" size="small" />
                        )}
                      </StyledBodyCell>
                       <StyledBodyCell align="center">
                              {data.Raisedby || '-'}
                      </StyledBodyCell>

                      <StyledBodyCell
                        align="center"
                        sx={{
                          position: { xs: 'static', md: 'sticky' },
                          right: 0,
                          bgcolor: 'inherit',
                          zIndex: 1,
                          backdropFilter: 'blur(20px)',
                        }}
                      >
                        <Stack direction="row" spacing={0.25} justifyContent="center" alignItems="center">
                          {isDraft && (
                            <Button
                              variant="contained"
                              color="warning"
                              size="small"
                              onClick={() => handleEdit(data)}
                              sx={{ fontSize: '0.72rem', minWidth: 0, px: 0.75, py: 0.25, fontWeight: 700 }}
                            >
                              Resume
                            </Button>
                          )}

                          {!isDraft && (
                            <Tooltip title="Edit">
                              <IconButton size="small" color="primary" onClick={() => handleEdit(data)}>
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}

                          
                            <Tooltip title="Delete">
                              <IconButton size="small" color="error" onClick={() => handleDelete(data)}>
                                <DeleteForeverIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          
                        </Stack>
                      </StyledBodyCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
            mt={2}
          />
        </>
      </Collapse>

      {rows.length === 0 && <NoResultsFound />}

  

      {/* ===== COUNTRY MISMATCH DIALOG ===== */}
      <Dialog open={customerMismatchOpen} onClose={() => setCustomerMismatchOpen(false)}>
        <DialogTitle>Change Country</DialogTitle>
        <DialogContent>
          <Typography>{customerMismatchMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCustomerMismatchOpen(false)} color="warning">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* ===== DELETE CONFIRMATION DIALOG ===== */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this pre-booking?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* ===== ADD/EDIT DIALOG ===== */}
      <Dialog
        fullScreen
        open={isDialogOpen}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          handleCloseDialog();
        }}
        disableEscapeKeyDown
        PaperProps={{ sx: { display: 'flex', flexDirection: 'column', height: '100vh', maxHeight: '100vh' } }}
      >
        <DialogTitle>
          <Typography
            variant="h5"
            p={1}
            textAlign={'center'}
            borderRadius={8}
            color="white"
            sx={{
              background:
                form.ShipMode === 'courier'
                  ? 'linear-gradient(to right, #667db6, #0082c8, #0082c8, #667db6)'
                  : 'linear-gradient(to right, #4ecdc4, #556270)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              {isEditing ? 'Edit Pre-Booking' : 'Pre-Booking Creation'}
            </Typography>
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ flex: 1, overflowY: 'auto', px: 3, py: 2 }}>
          <Stack spacing={2} sx={{ mt: 1 }}>
            {/* BASIC DETAILS */}
            <Box>
              <Divider sx={{ mb: 2 }}>
                <Chip label="Basic Details" size="small" color="primary" />
              </Divider>
             {isEditing && isBookedPreBooking && (
  <Box
    role="status"
    sx={{
      mb: 2,
      px: 2,
      py: 1,
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      flexWrap: 'wrap',
      borderRadius: 1.5,
      border: '1px solid',
      borderColor: 'warning.light',
      background: 'linear-gradient(90deg, #fff8e1 0%, #fffdf5 100%)',
      boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 22,
        height: 22,
        borderRadius: '50%',
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        flexShrink: 0,
      }}
    >
      <LockIcon sx={{ fontSize: 14 }} />
    </Box>

    <Typography
      variant="body2"
      sx={{ fontWeight: 600, color: 'warning.dark', whiteSpace: 'nowrap' }}
    >
      Basic details locked — pre-booking already booked
    </Typography>

    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, ml: 'auto' }}>
      {isBookedInWindows && (
        <Chip
          label="Windows"
          size="small"
          color="warning"
          variant="outlined"
          sx={{ height: 20, fontSize: '0.7rem', fontWeight: 600 }}
        />
      )}
      {isBookedInWeb && (
        <Chip
          label="Web"
          size="small"
          color="info"
          variant="outlined"
          sx={{ height: 20, fontSize: '0.7rem', fontWeight: 600 }}
        />
      )}
    </Box>
  </Box>
)}
              <Grid container spacing={2}>
                {isSalesUser && (
                  <Grid item xs={12} md={0.5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Tooltip title={withoutuser ? 'Showing all customers' : 'Showing my customers only'}>
                      <label
                        className="prebooking-customer-scope"
                        htmlFor="prebooking-dialog-customer-scope-checkbox"
                      >
                        <input
                          id="prebooking-dialog-customer-scope-checkbox"
                          className="prebooking-customer-scope__input"
                          type="checkbox"
                          checked={withoutuser}
                          onChange={() => {
                            setForm((prev) => ({ ...prev, CustomerId: 0 }));
                            handleWithoutUserToggle();
                          }}
                          aria-label="Toggle all customer scope"
                        />
                        <span className="prebooking-customer-scope__box">
                          <svg aria-hidden="true" viewBox="0 0 28 28">
                            <path d="M4 14l8 7L24 7" />
                          </svg>
                        </span>
                      </label>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item xs={12} md={2.5}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Search By"
                    value={form.searchByField || 'phonenumber'}
                    onChange={(e) => setForm({ ...form, searchByField: e.target.value })}
                    disabled={(isEditing && !isDraftEditing) || isBookedPreBooking}
                  >
                    {searchByOptions.map((o) => (
                      <MenuItem key={o.value} value={o.value}>
                        {o.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={3}>
                  <div
                    ref={(el) => {
                      fieldRefs.current.CustomerId = el;
                    }}
                  >
                    <Autocomplete
                      key={form.searchByField}
                      options={customerList}
                      getOptionLabel={(c) => {
                        if (!c) return '';
                        if (form.searchByField === 'phonenumber') return c.Phone || '';
                        if (form.searchByField === 'emailid') return c.EmailId || c.emailId || c.EMAILID || '';
                        return c.CUSTOMERNAME || c.CustomerName || '';
                      }}
                      renderOption={(props, c) => (
                        <li {...props} key={getCustomerIdValue(c)}>
                          {form.searchByField === 'phonenumber'
                            ? c.Phone || ''
                            : form.searchByField === 'emailid'
                            ? c.EmailId || c.emailId || c.EMAILID || ''
                            : c.CUSTOMERNAME || c.CustomerName || ''}
                        </li>
                      )}
                      isOptionEqualToValue={(o, v) => getCustomerIdValue(o) === getCustomerIdValue(v)}
                      value={
                        selectedCustomer ||
                        customerList.find((c) => Number(getCustomerIdValue(c)) === Number(form.CustomerId || 0)) ||
                        null
                      }
                      onChange={handleCustomerSelect}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <RequiredLabel>
                              Search By {searchByOptions.find((option) => option.value === form.searchByField)?.label || 'Phone Number'}
                            </RequiredLabel>
                          }
                          error={submitAttempted && !!errors.CustomerId}
                          helperText={submitAttempted ? errors.CustomerId || '' : ''}
                          disabled={(isEditing && !isDraftEditing) || isBookedPreBooking}
                        />
                      )}
                      disabled={(isEditing && !isDraftEditing) || isBookedPreBooking}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Shipment Type"
                    name="ShipMode"
                    value={form.ShipmentTypeValue || getDefaultShipmentTypeValue()}
                    onChange={handleChange}
                    disabled={isEditing || isBookedPreBooking}
                  >
                    {(origin === 'IN'
                      ? shipmentTypeOptionsIN
                      : origin === 'UK'
                      ? shipmentTypeOptionsUK
                      : shipmentTypeOptionsSL
                    ).map((o) => (
                      <MenuItem key={o.value} value={o.value}>
                        {o.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    options={filteredShipperList}
                    getOptionLabel={(s) => s.AgentName || s.ShipperLinerName || ''}
                    renderOption={(props, s) => (
                      <li {...props} key={s.AgentId || s.ShipperLinerId}>
                        {s.AgentName || s.ShipperLinerName || ''}
                      </li>
                    )}
                    isOptionEqualToValue={(o, v) =>
                      Number(o.AgentId ?? o.ShipperLinerId) === Number(v?.AgentId ?? v?.ShipperLinerId ?? 0)
                    }
                    value={
                      filteredShipperList.find(
                        (s) => Number(s.AgentId ?? s.ShipperLinerId ?? 0) === Number(form.ShipperLinerId)
                      ) || null
                    }
                    onChange={handleShipperSelect}
                    size="small"
                    renderInput={(params) => <TextField {...params} label="Shipper" disabled={isFieldDisabled()} />}
                    disabled={isFieldDisabled()}
                  />
                </Grid>
                <Grid item xs={12} md={2.5}>
                  <Autocomplete
                    options={senderCountryOptions}
                    getOptionLabel={(c) => c.CountryName || ''}
                    renderOption={(props, c) => (
                      <li {...props} key={c.CountryId}>
                        {c.CountryName}
                      </li>
                    )}
                    isOptionEqualToValue={(o, v) => Number(o.CountryId) === Number(v?.CountryId || 0)}
                    value={
                      senderCountryOptions.find((c) => Number(c.CountryId) === Number(form.SenCountryId || 0)) ||
                      senderCountryOptions[0] ||
                      null
                    }
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<RequiredLabel>Sender Country</RequiredLabel>}
                        error={submitAttempted && !!errors.SenCountryId}
                        helperText={submitAttempted ? errors.SenCountryId || '' : ''}
                        disabled
                      />
                    )}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={2.5}>
                  <div
                    ref={(el) => {
                      fieldRefs.current.RecCountryId = el;
                    }}
                  >
                    <Autocomplete
                      options={receiverCountryOptions}
                      getOptionLabel={(c) => c.CountryName || ''}
                      renderOption={(props, c) => (
                        <li {...props} key={c.CountryId}>
                          {c.CountryName}
                        </li>
                      )}
                      isOptionEqualToValue={(o, v) => Number(o.CountryId) === Number(v?.CountryId || 0)}
                      value={
                        receiverCountryOptions.find((c) => Number(c.CountryId) === Number(form.RecCountryId || 0)) ||
                        null
                      }
                      onChange={(e, v) => {
                        const id = Number(v?.CountryId || 0);
                        setForm((prev) => ({
                          ...prev,
                          RecCountryId: id,
                          ReceiverCountry: v?.CountryName || '',
                          RecProvince: '',
                          RecStateId: 0,
                        }));
                        setErrors((prev) => {
                          const n = { ...prev };
                          delete n.RecCountryId;
                          return n;
                        });
                        if (id) getReceiverState(id);
                        else setReceiverStateList([]);
                      }}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={<RequiredLabel>Receiver Country</RequiredLabel>}
                          error={submitAttempted && !!errors.RecCountryId}
                          helperText={submitAttempted ? errors.RecCountryId || '' : ''}
                          disabled={isFieldDisabled()}
                        />
                      )}
                      disabled={isFieldDisabled()}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label={<RequiredLabel>Document Type</RequiredLabel>}
                    name="PreDocType"
                    value={form.PreDocType || 'NonDocument'}
                    onChange={handleChange}
                    error={submitAttempted && !!errors.PreDocType}
                    helperText={submitAttempted ? errors.PreDocType || '' : ''}
                    disabled={isFieldDisabled()}
                  >
                    {documentTypeOptions.map((o) => (
                      <MenuItem key={o.value} value={o.value}>
                        {o.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {/* <Grid item xs={12} md={1.5}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label={<RequiredLabel>Dim</RequiredLabel>}
                    name="Dimension"
                    value={form.Dimension || 'CM'}
                    onChange={handleChange}
                    error={submitAttempted && !!errors.Dimension}
                    helperText={submitAttempted ? errors.Dimension || '' : ''}
                    disabled={isFieldDisabled()}
                  >
                    {dimensionOptions.map((o) => (
                      <MenuItem key={o.value} value={o.value}>
                        {o.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid> */}
                <Grid item xs={12} md={1.5}>
                  <TextField
                    type="date"
                    fullWidth
                    size="small"
                    label={<RequiredLabel>Pre-Booking Date</RequiredLabel>}
                    name="PreBookDate"
                    value={form.PreBookDate}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    disabled={isFieldDisabled(true)}
                  />
                </Grid>
                {/* <Grid item xs={12} md={1}>
                  <TextField
                    fullWidth
                    size="small"
                    label="No Box"
                    name="NoOfBox"
                    type="number"
                    inputProps={{ min: 1 }}
                    value={form.NoOfBox || 1}
                    onChange={handleChange}
                    error={submitAttempted && !!errors.NoOfBox}
                    helperText={submitAttempted ? errors.NoOfBox || '' : ''}
                    disabled={isFieldDisabled()}
                  />
                </Grid> */}
                <Grid item xs={12} md={2}>
                  <div
                    ref={(el) => {
                      fieldRefs.current.Branch = el;
                    }}
                  >
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label={<RequiredLabel>Branch</RequiredLabel>}
                      name="Branch"
                      value={form.Branch || ''}
                      onChange={handleChange}
                      error={submitAttempted && !!errors.Branch}
                      helperText={submitAttempted ? errors.Branch || '' : ''}
                      disabled={isFieldDisabled()}
                    >
                      <MenuItem value="">Select Branch</MenuItem>
                      {branchList.map((b) => (
                        <MenuItem key={b.BranchId} value={b.BranchId}>
                          {b.BranchName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </Grid>
                <Grid item xs={12} md={1.5}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={form.IntoBooking === 'Y'}
                        onChange={(e) =>
                          setForm((prev) => ({
                            ...prev,
                            IntoBooking: e.target.checked ? 'Y' : 'N',
                          }))
                        }
                        color="primary"
                        disabled={isFieldDisabled()}
                      />
                    }
                    label="Into Booking"
                  />
                </Grid>
              </Grid>

              {!isAdmin && !showBookingDetails && (
                <Stack direction="row" justifyContent="center" spacing={1} sx={{ mt: 2 }}>
                  <Button variant="contained" color="warning" onClick={handleCloseFromBasicDetails}>
                    Close
                  </Button>
                    <Button variant="contained" color="error" onClick={resetForm}>
                    Reset
                  </Button>
                  <Button variant="contained" color="success" onClick={handleStartBooking}>
                    Start Booking
                  </Button>
                </Stack>
              )}
            </Box>

            {showBookingDetails && (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ border: '1px solid #E0F2FE', borderRadius: 2, p: 2, height: '100%' }}>
                      <Box
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 1 }}
                      >
                        <Divider sx={{ flexGrow: 1 }}>
                          <Chip label="Sender Details" size="small" color="info" />
                        </Divider>
                        <FormControlLabel
                          sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '13px', whiteSpace: 'nowrap' } }}
                          control={
                            <Checkbox
                              size="small"
                              checked={form.SameAsCustomer === 'Y'}
                              onChange={handleSameAsCustomerToggle}
                              color="primary"
                              disabled={isFieldDisabled() || !form.CustomerId}
                            />
                          }
                          label="Same as Customer"
                        />
                      </Box>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label={<RequiredLabel>Name</RequiredLabel>}
                            name="SName"
                            value={form.SName}
                            onChange={handleChange}
                            error={submitAttempted && !!errors.SName}
                            helperText={submitAttempted ? errors.SName || '' : ''}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label={<RequiredLabel>Contact No</RequiredLabel>}
                            name="SContactNo"
                            value={form.SContactNo}
                            onChange={handleChange}
                            error={submitAttempted && !!errors.SContactNo}
                            helperText={submitAttempted ? errors.SContactNo || '' : ''}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Atl No"
                            name="SAtlNo"
                            value={form.SAtlNo}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label={<RequiredLabel>Email</RequiredLabel>}
                            name="SEmailId"
                            value={form.SEmailId}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label={<RequiredLabel>Address Line 1</RequiredLabel>}
                            name="SAdd1"
                            value={form.SAdd1}
                            onChange={handleChange}
                            error={submitAttempted && !!errors.SAdd1}
                            helperText={submitAttempted ? errors.SAdd1 || '' : ''}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Address Line 2"
                            name="SAdd2"
                            value={form.SAdd2}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Address Line 3"
                            name="SAdd3"
                            value={form.SAdd3}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label="City"
                            name="SCity"
                            value={form.SCity}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            options={senderCountryOptions}
                            getOptionLabel={(c) => c.CountryName || ''}
                            renderOption={(props, c) => (
                              <li {...props} key={c.CountryId}>
                                {c.CountryName}
                              </li>
                            )}
                            isOptionEqualToValue={(o, v) => Number(o.CountryId) === Number(v?.CountryId)}
                            value={
                              senderCountryOptions.find((c) => Number(c.CountryId) === Number(form.SenCountryId)) ||
                              senderCountryOptions[0] ||
                              null
                            }
                            size="small"
                            renderInput={(params) => (
                              <TextField {...params} label={<RequiredLabel>Sender Country</RequiredLabel>} disabled />
                            )}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            options={senderStateList}
                            getOptionLabel={(s) => s.StateName || ''}
                            renderOption={(props, s) => (
                              <li {...props} key={s.StateId}>
                                {s.StateName}
                              </li>
                            )}
                            isOptionEqualToValue={(o, v) => Number(o.StateId) === Number(v?.StateId)}
                            value={senderStateList.find((s) => Number(s.StateId) === Number(form.SenStateId)) || null}
                            onChange={(e, v) =>
                              setForm({ ...form, SenStateId: Number(v?.StateId || 0), SenProvince: v?.StateName || '' })
                            }
                            size="small"
                            renderInput={(params) => (
                              <TextField {...params} label="Sender Province/State" disabled={isFieldDisabled()} />
                            )}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Postal Code"
                            name="Senpincode"
                            value={form.Senpincode}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Box sx={{ border: '1px solid #FCE7F3', borderRadius: 2, p: 2, height: '100%' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Divider sx={{ flexGrow: 1 }}>
                          <Chip label="Receiver Details" size="small" color="secondary" />
                        </Divider>
                      </Box>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            options={receiverList}
                            getOptionLabel={(receiver) =>
                              typeof receiver === 'string' ? receiver : receiver?.receiver_Name || ''
                            }
                            filterOptions={(options, state) => {
                              const inputValue = state.inputValue.toLowerCase();
                              return options.filter((receiver) =>
                                String(receiver.receiver_Name || '').toLowerCase().includes(inputValue) ||
                                String(receiver.receiver_ContactNo || '').toLowerCase().includes(inputValue)
                              );
                            }}
                            renderOption={(props, receiver) => (
                              <li {...props} key={receiver.receiver_Id}>
                                <div>
                                  <strong>{receiver.receiver_Name}</strong>
                                  <div style={{ fontSize: '0.8rem', color: '#666' }}>
                                    {receiver.receiver_ContactNo}
                                  </div>
                                </div>
                              </li>
                            )}
                            isOptionEqualToValue={(option, value) => {
                              if (!option || !value) return false;
                              if (typeof value === 'string') return option.receiver_Name === value;
                              return option.receiver_Id === value.receiver_Id;
                            }}
                            value={
                              receiverList.find(
                                (receiver) =>
                                  receiver.receiver_Name === form.RName &&
                                  receiver.receiver_ContactNo === form.RContactNo
                              ) || form.RName || null
                            }
                            onChange={(event, value) => {
                              if (value && typeof value === 'object') {
                                setForm((prev) => ({
                                  ...prev,
                                  RName: value.receiver_Name || '',
                                  RContactNo: value.receiver_ContactNo || '',
                                  RAtlNo: value.receiver_AlterContactNo || '',
                                  REmailId: value.receiver_EmailId || '',
                                  RAdd1: value.receiver_Address1 || '',
                                  RAdd2: value.receiver_Address2 || '',
                                  RAdd3: value.receiver_Address3 || '',
                                  RCity: value.receiver_City || '',
                                  RecPincode: value.receiver_Pincode || '',
                                  RecStateId: Number(value.receiver_Stateid || 0),
                                  RecProvince: value.receiver_StateName || '',
                                }));
                              } else {
                                setForm((prev) => ({ ...prev, RName: value || '' }));
                              }
                              setErrors((prev) => {
                                const next = { ...prev };
                                delete next.RName;
                                return next;
                              });
                            }}
                            onInputChange={(event, newInputValue, reason) => {
                              if (reason === 'input' || reason === 'clear') {
                                setForm((prev) => ({ ...prev, RName: newInputValue }));
                              }
                            }}
                            size="small"
                            freeSolo
                            disabled={isFieldDisabled()}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={<RequiredLabel>Name</RequiredLabel>}
                                inputRef={(element) => {
                                  fieldRefs.current.RName = element;
                                }}
                                error={submitAttempted && !!errors.RName}
                                helperText={submitAttempted ? errors.RName || '' : ''}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label={<RequiredLabel>Contact No</RequiredLabel>}
                            name="RContactNo"
                            value={form.RContactNo}
                            onChange={handleChange}
                            error={submitAttempted && !!errors.RContactNo}
                            helperText={submitAttempted ? errors.RContactNo || '' : ''}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Atl No"
                            name="RAtlNo"
                            value={form.RAtlNo}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Email"
                            name="REmailId"
                            value={form.REmailId}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label={<RequiredLabel>Address Line 1</RequiredLabel>}
                            name="RAdd1"
                            value={form.RAdd1}
                            onChange={handleChange}
                            error={submitAttempted && !!errors.RAdd1}
                            helperText={submitAttempted ? errors.RAdd1 || '' : ''}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Address Line 2"
                            name="RAdd2"
                            value={form.RAdd2}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Address Line 3"
                            name="RAdd3"
                            value={form.RAdd3}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label="City"
                            name="RCity"
                            value={form.RCity}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            options={receiverCountryOptions}
                            getOptionLabel={(c) => c.CountryName || ''}
                            renderOption={(props, c) => (
                              <li {...props} key={c.CountryId}>
                                {c.CountryName}
                              </li>
                            )}
                            isOptionEqualToValue={(o, v) => Number(o.CountryId) === Number(v?.CountryId)}
                            value={
                              receiverCountryOptions.find((c) => Number(c.CountryId) === Number(form.RecCountryId)) ||
                              null
                            }
                            onChange={(e, v) => {
                              const id = Number(v?.CountryId || 0);
                              setForm({
                                ...form,
                                RecCountryId: id,
                                ReceiverCountry: v?.CountryName || '',
                                RecProvince: '',
                                RecStateId: 0,
                              });
                              if (id) getReceiverState(id);
                              else setReceiverStateList([]);
                            }}
                            size="small"
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={<RequiredLabel>Receiver Country</RequiredLabel>}
                                disabled={isFieldDisabled()}
                              />
                            )}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            options={receiverStateList}
                            getOptionLabel={(s) => s.StateName || ''}
                            renderOption={(props, s) => (
                              <li {...props} key={s.StateId}>
                                {s.StateName}
                              </li>
                            )}
                            isOptionEqualToValue={(o, v) => Number(o.StateId) === Number(v?.StateId)}
                            value={receiverStateList.find((s) => Number(s.StateId) === Number(form.RecStateId)) || null}
                            onChange={(e, v) =>
                              setForm({ ...form, RecStateId: Number(v?.StateId || 0), RecProvince: v?.StateName || '' })
                            }
                            size="small"
                            renderInput={(params) => (
                              <TextField {...params} label="Receiver Province/State" disabled={isFieldDisabled()} />
                            )}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Postal Code"
                            name="RecPincode"
                            value={form.RecPincode}
                            onChange={handleChange}
                            disabled={isFieldDisabled()}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>

                <Box>
                  <Divider sx={{ mb: 2 }}>
                    <Chip label="Payment & Shipment Status" size="small" color="warning" />
                  </Divider>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        label="Pay Mode"
                        name="PrePayMode"
                        value={form.PrePayMode || 'Cash'}
                        onChange={handleChange}
                        error={submitAttempted && !!errors.PrePayMode}
                        helperText={submitAttempted ? errors.PrePayMode || '' : ''}
                        disabled={isFieldDisabled()}
                      >
                        {payModeOptions.map((o) => (
                          <MenuItem key={o.value} value={o.value}>
                            {o.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        label="Ship Mode"
                        name="ShipModeValue"
                        value={form.ShipModeValue || 'Air'}
                        onChange={handleChange}
                        error={submitAttempted && !!errors.ShipModeValue}
                        helperText={submitAttempted ? errors.ShipModeValue || '' : ''}
                        disabled={isFieldDisabled()}
                      >
                        {shipModeOptions.map((o) => (
                          <MenuItem key={o.value} value={o.value}>
                            {o.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <div
                        ref={(el) => {
                          fieldRefs.current.BookingStatus = el;
                        }}
                      >
                        <Autocomplete
                          options={bookingStatusOptions}
                          getOptionLabel={(o) => o?.label || ''}
                          isOptionEqualToValue={(o, v) => o?.value === v?.value}
                          value={
                            bookingStatusOptions.find(
                              (o) => o.value === normalizeBookingStatus(form.BookingStatus || form.Status)
                            ) || null
                          }
                          onChange={(e, v) => {
                            setForm((prev) => ({
                              ...prev,
                              BookingStatus: v?.value || '',
                              Status: v?.value || '',
                            }));
                            setErrors((prev) => {
                              const n = { ...prev };
                              delete n.BookingStatus;
                              return n;
                            });
                          }}
                          size="small"
                          clearOnBlur={false}
                          disableClearable={false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label= "Booking Status"
                              error={submitAttempted && !!errors.BookingStatus}
                              helperText={submitAttempted ? errors.BookingStatus || '' : ''}
                              disabled={isFieldDisabled(true)}
                            />
                          )}
                          disabled={isFieldDisabled(true)}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Pickup Miles"
                        name="PickupMiles"
                        type="text"
                        inputMode="decimal"
                        placeholder="e.g. 1234.69"
                        value={form.PickupMiles}
                        onChange={handleChange}
                        inputProps={{ maxLength: 12 }}
                        error={!!errors.PickupMiles}
                        helperText={errors.PickupMiles || ''}
                        disabled={isFieldDisabled()}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Pickup Charges"
                        name="PickupCharges"
                        type="text"
                        inputMode="decimal"
                        placeholder="e.g. 1234.69"
                        value={form.PickupCharges}
                        onChange={handleChange}
                        inputProps={{ maxLength: 12 }}
                        error={!!errors.PickupCharges}
                        helperText={errors.PickupCharges || ''}
                        disabled={isFieldDisabled()}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Pickup Address"
                        name="PickupAddress"
                        value={form.PickupAddress}
                        onChange={handleChange}
                        disabled={isFieldDisabled()}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Postal Code"
                        name="PostalCode"
                        value={form.PostalCode}
                        onChange={handleChange}
                        disabled={isFieldDisabled()}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        label="Pickup Branch"
                        name="PickupBranchId"
                        value={form.PickupBranchId || ''}
                        onChange={handleChange}
                        disabled={isFieldDisabled()}
                      >
                        <MenuItem value="">Select Pickup Branch</MenuItem>
                        {branchList.map((b) => (
                          <MenuItem key={b.BranchId} value={b.BranchId}>
                            {b.BranchName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        type="date"
                        fullWidth
                        size="small"
                        label="Pickup Date"
                        name="PickupDate"
                        value={form.PickupDate}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        error={submitAttempted && !!errors.PickupDate}
                        helperText={submitAttempted ? errors.PickupDate || '' : ''}
                        disabled={isFieldDisabled(true)}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        type="time"
                        fullWidth
                        size="small"
                        label="Pickup Time"
                        name="PickupTime"
                        value={form.PickupTime}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        error={submitAttempted && !!errors.PickupTime}
                        helperText={submitAttempted ? errors.PickupTime || '' : ''}
                        disabled={isFieldDisabled(true)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Remarks"
                        name="Remark"
                        multiline
                        rows={2}
                        value={form.Remark}
                        onChange={handleChange}
                        helperText={errors.Remark || `${String(form.Remark || '').length}/150 characters`}
                        error={!!errors.Remark}
                        inputProps={{ maxLength: 150 }}
                        disabled={isFieldDisabled()}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </>
            )}
          </Stack>
        </DialogContent>

        <DialogActions
          sx={{
            position: 'sticky',
            bottom: 0,
            zIndex: 2,
            backgroundColor: '#fff',
            borderTop: '1px solid rgba(0, 0, 0, 0.12)',
            px: 3,
            py: 1.5,
            justifyContent: 'center',
          }}
        >
         {showBookingDetails && (
            <Button variant="contained" color="warning" onClick={handleCloseDialog}>
              Close
            </Button>
          )}
          {showBookingDetails && (!isAdmin || isEditing) && (
            <>
              {( form.IsDraft === 'Y') && (
                <Button variant="outlined" color="primary" onClick={() => handleSubmit(true)}>
                  Save Draft
                </Button>
              )}
              <Button variant="contained" color="success" onClick={() => handleSubmit(false)}>
                {form.IsDraft === 'Y' ? 'Save Pre-Booking' : 'Update Pre-Booking'}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default PreBooking;